<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Add/Edit Country</h2>
    </div>
    <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
        <i class="fa fa-times close" @click="onClosed()" />
        <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
  </div>

  <div class="wrapper wrapper-content px-0">
    <div class="ibox-content p-3">
      <div class="form-group row">

        <!-- Country Name -->
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.country name") }}
            <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <select v-model="selectedCountryId" @change="onCountrySelect" class="form-control">
            <option value="" disabled>Select Country</option>
            <option v-for="c in allCountries" :key="c.id" :value="c.id">{{ c.country }}</option>
          </select>
           <small v-if="countryNameError" class="errorClass">Country name is required</small>
        </div>
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.country code") }}
          </label>
          <input type="text" class="form-control" v-model="country.countryCode" readonly />
        </div>
        <!-- Language -->
        <div class="col-lg-4 mb-1">
          <label class="">{{ $t("navigations.language") }}</label>
          <Multiselect v-model="selectedLanguages" mode="multiple" :searchable="true" trackBy="language" valueProp="code"
            label="language" :options="languages" :hideSelected="false" :closeOnSelect="false"
            placeholder="Select Languages" class="multiselect-template-theme mr-0 mt-1" 
            />
<!-- :multiple-label="values => values.map(v => v.language).join(', ')" -->
        </div>

        <!-- Region -->
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.region") }}</label>
          <input type="text" class="form-control" v-model="country.region" maxlength="50" />
        </div>
        <!-- Status -->
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.status") }}</label>
           <select class="form-select mb-2" name="reason to resolve" id="resolveReason" v-model="country.status">
            <option value="" disabled>Select Status</option>
        <option v-for="reason in CountryStatus" :key="reason.status" :value="reason.status">{{ reason.status }}</option>
      </select>

        </div>
        <!-- <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.status date") }}</label>
          <input type="date" class="form-control" v-model="country.statusDate" maxlength="50" />
        </div> -->
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.contact person") }}</label>
          <input type="text" class="form-control" v-model="country.contactPerson" maxlength="50" />
        </div>
          <div class="col-lg-4 mb-1">
          <label class="">{{ $t("navigations.default language") }}</label>
          <select class="form-select mb-2" v-model="defaultLanguages" valueProp="code"
            label="language"
            placeholder="Select Languages"
            @change="onCountrySelect"
            >
            <option v-for="lang in languages" :key="lang.code" :value="lang.code">{{ lang.language }}</option>
          </select>
<!-- :multiple-label="values => values.map(v => v.language).join(', ')" -->
        </div>
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.regulatory authority") }}</label>
          <input type="text" class="form-control" v-model="country.regulatoryAuthority" maxlength="50" />
        </div>
        <!-- Description -->
        <div class="col-lg-4 mb-2">
          <label class="col-form-label">{{ $t("navigations.notes") }}</label>
          <textarea class="form-control" v-model="country.notes" maxlength="50"></textarea>
        </div>


        <!-- Status -->
        <div class="col-lg-4 mb-2 d-flex align-items-center">
          <label class="mr-2">{{ $t("navigations.active") }}</label>
          <input type="checkbox" v-model="country.active" />
        </div>
      </div>

      <!-- Buttons -->
      <div class="form-group row">
        <div class="col-lg-12 my-3 d-flex justify-content-end">
          <button class="cancel_btn py-1 px-4 mx-3" type="button" @click="clear">
            {{ $t("navigations.clear") }}
          </button>
         <button class="save_btn py-1 px-4" type="button" @click="save">
            {{ isEditMode ? $t("navigations.update") : $t("navigations.save") }}
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ManageCountry.js"></script>
<style scoped>
.errorClass {
    color: red;
    font-size: 0.875rem
}
</style>